import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SvgProps, Svg } from '../../Svg';

const Icon: React.FC<SvgProps> = props => {
  const themeContext = useContext(ThemeContext);

  return (
    <Svg
      width="12"
      height="13"
      viewBox="0 0 12 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.49997 6.49979C9.22348 6.49979 9 6.72383 9 6.99978V10.9999C9 11.2754 8.77597 11.4999 8.50003 11.4999H1.5C1.22397 11.4999 1.00003 11.2754 1.00003 10.9999V3.99968C1.00003 3.72419 1.22397 3.4997 1.5 3.4997H5.50003C5.77652 3.4997 6 3.27566 6 2.99971C6 2.72367 5.77652 2.49963 5.50003 2.49963H1.5C0.673004 2.49963 0 3.17266 0 3.99968V10.9999C0 11.827 0.673004 12.5 1.5 12.5H8.50003C9.32703 12.5 10 11.827 10 10.9999V6.99978C10 6.72328 9.77646 6.49979 9.49997 6.49979Z"
        fill={themeContext.colors.font1}
      />
      <path
        d="M4.68794 6.04432C4.65297 6.07929 4.62944 6.12379 4.61946 6.17176L4.26597 7.93989C4.2495 8.02183 4.2755 8.10633 4.33446 8.16585C4.38197 8.21336 4.44597 8.23882 4.51152 8.23882C4.52745 8.23882 4.54402 8.23735 4.5605 8.23387L6.32802 7.88038C6.377 7.8703 6.42149 7.84687 6.45601 7.8118L10.412 3.85568L8.64448 2.0882L4.68794 6.04432Z"
        fill={themeContext.colors.font1}
      />
      <path
        d="M11.634 0.865651C11.1465 0.378116 10.3535 0.378116 9.86646 0.865651L9.1745 1.55763L10.942 3.3252L11.634 2.63313C11.87 2.39765 12 2.08362 12 1.74962C12 1.41563 11.87 1.10159 11.634 0.865651Z"
        fill={themeContext.colors.font1}
      />
    </Svg>
  );
};

export default Icon;
